// Paths whose URL is itself a credential (a share-link token). Nothing about
// such a visit may be sent to third parties: analytics must not initialise on
// them, and screen tracking must not report the path. Pure so it can be unit
// tested in the node test environment.

/** Prefix of the public Locked site-share page: `/site-share/<token>`. */
export const PRIVATE_SHARE_PATH_PREFIX = "/site-share/";

/** What analytics may be told instead of the real path. */
export const REDACTED_SHARE_PATH = "/site-share/:token";

export function isPrivateSharePath(pathname: string | null | undefined): boolean {
  return typeof pathname === "string" && pathname.toLowerCase().startsWith(PRIVATE_SHARE_PATH_PREFIX);
}

/** The path to report to analytics: share paths are collapsed so the token never leaves the browser. */
export function redactSharePath(pathname: string): string {
  return isPrivateSharePath(pathname) ? REDACTED_SHARE_PATH : pathname;
}
